import { Link } from "react-router-dom"

import './help.css'

export default function Help() {

  return (
    <div className="help" >
      <br />
      <h2>Help Menu</h2>
      <br />
      <p>Home: You can see all the jokes in Home which are ordered
        by their star rating.</p>
      <p>Rate It: You can rate jokes by the "Rate It" button on each joke.</p>
      <br />
      <p>Create: You can create a joke.  Profanity will be deleted. </p>
      <br />
      <p>myJokes: And you can see and delete your jokes in myJokes. </p>
      <br />
      <p>Contact info RepairDude7@gmail.com</p>
      <br />
      <br />
      <Link className="btnYes" to="/">Home</Link>

    </div>
  )
}